import { createSelector } from 'reselect';
import { fromJS } from 'immutable';

/**
 * Direct selector to the login state domain
 */
const selectLoginDomain = () => (state) => state.get('login', fromJS({}));

/**
 * Other specific selectors
 */

/**
 * Default selector used by Login
 */

const selectLogin = () =>
  createSelector(selectLoginDomain(), (substate) => substate.toJS());

const selectUsername = () =>
  createSelector(selectLoginDomain(), (substate) => substate.get('username'));

const selectPassword = () =>
  createSelector(selectLoginDomain(), (substate) => substate.get('password'));

const selectTwoFaCode = () =>
  createSelector(selectLoginDomain(), (substate) => substate.get('twoFaCode'));

const selectUserId = () =>
  createSelector(selectLoginDomain(), (substate) => substate.get('userId'));

const selectRecaptchaToken = () =>
  createSelector(selectLoginDomain(), (substate) =>
    substate.get('recaptchaToken')
  );

const selectDomainAuthMethod = () =>
  createSelector(selectLoginDomain(), (substate) =>
    substate.get('domainAuthMethod')
  );

export default selectLogin;
export {
  selectLoginDomain,
  selectRecaptchaToken,
  selectUsername,
  selectPassword,
  selectDomainAuthMethod,
  selectTwoFaCode,
  selectUserId,
};
